module.exports = require('./lib/ObjectPath.js').ObjectPath;



//////////////////
// WEBPACK FOOTER
// ./~/objectpath/index.js
// module id = 465
// module chunks = 0